import {
  Button,
  Card,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react"; // Ajout de useState
import { MdAdd, MdMail } from "react-icons/md";

import useDataFetching from "hooks/useDataFetching";
import { config } from "variables/config";
import PreloaderSpinner from "components/PreloaderSpinner";
import UpdateRole from "./UpdateRole";
import AddRole from "./AddRole";
import { useAuthUser } from "react-auth-kit";
import { CHECK_PERMISSIONS } from "Constaints";
import { FormControlLabel, Switch } from "@mui/material";
import usePostAxiosData from "hooks/usePostAxiosData";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const Roles = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation("roles"); // Utiliser le namespace "roles"

  const [isOpenUM, setIsOpenUM] = useState(false);
  const [closeUM, setCloseUM] = useState(false);
  const [loadingR, errorR, roles, fetchDataU] = useDataFetching(
    `${config.app.api_url}/roles`
  );

  const [loadingS, errorS, setting, fetchSettings] = useDataFetching(
    `${config.app.api_url}/settings`
  );

  const auth = useAuthUser();
  const [loadingU2, errorU2, usr, fetchDataU2] = useDataFetching(
    `${config.app.api_url}/users/${auth()?.user?.id}`
  );

  const [loadingNot, postNotify, errorNot, successMessageNot, resultNot] = usePostAxiosData(`schedulers/notify-enterprise-employees-status`, "PUT");
  const [loadingE, postE, errorE, successMessageE, resultE] = usePostAxiosData(`settings/enable-enterprise-notifier`, "PUT");
  const [loadingD, postD, errorD, successMessageD, resultD] = usePostAxiosData(`settings/disable-enterprise-notifier`, "PUT");

  useEffect(() => {
    fetchSettings();
  }, [successMessageE, successMessageD, fetchSettings]); // Ajout de fetchSettings aux dépendances

  const [roleId, setRoleId] = useState(null);

  return (
    <div>
      {loadingR && <PreloaderSpinner />}
      <div className="mt-2 grid h-full grid-cols-1 gap-5">
        <div className="mt-5 flex justify-end gap-5 bg-white rounded p-3">

          {usr?.data?.roles.length > 0 &&
            usr?.data?.roles?.map((role) => {
              return (
                CHECK_PERMISSIONS(role?.permissions, "Ajouter un rôle") && (
                  <>
                    {setting?.data ? <FormControlLabel

                      control={<Switch checked={setting?.data?.activeAutoEnterpriseNotifier}
                        onChange={(e) => (e.target.checked ? postE() : postD())

                        }
                      />} label="Active Notifier"

                    /> : <p>{t("settings_loading")}</p>}

                    <Button onClick={() => postNotify()}
                      isDisabled={setting?.data?.activeAutoEnterpriseNotifier === false}
                      isLoading={loadingNot}
                      colorScheme="red"
                    >
                      <MdMail className="h-6 w-6" />
                      {t("notify_enterprise_now_button")}
                    </Button>
                    <Button onClick={() => onOpen()} colorScheme="blue" >
                      <MdAdd className="h-6 w-6" />
                      {t("add_role_button")}
                    </Button>
                  </>
                )
              );
            })}
        </div>
        <Table variant="simple" className="bg-white">
          <Thead>
            <Tr>
              <Th>{t("table_header_hash")}</Th> {/* Traduit */}
              <Th>{t("table_header_name")}</Th> {/* Traduit */}
              <Th>{t("table_header_permissions")}</Th> {/* Traduit */}
              <Th>{t("table_header_option")}</Th> {/* Traduit */}
            </Tr>
          </Thead>
          <Tbody>
            {roles?.data &&
              roles?.data?.map((role, index) => {
                return (
                  <Tr key={index}>
                    <Td>{index + 1}</Td>
                    <Td>{role?.name}</Td>
                    <Td>
                      <div
                        className="me-2 overflow-auto"
                        style={{ maxHeight: "40vh" }}
                      >
                        {role?.permissions &&
                          role?.permissions?.length === 0 ? (
                          <span className="flex justify-center text-orange-500">
                            {t("no_permission_assigned")} {/* Traduit */}
                          </span>
                        ) : (
                          role?.permissions
                            .sort((a, b) => {
                              return b?.name > a?.name ? -1 : 1;
                            })
                            .map((permission) => {
                              return (
                                <ul key={permission?.id}>
                                  <li className="py-1">
                                    {permission?.name ? (
                                      <i className="font-medium-400 text-gray-750 text-sm">
                                        {permission?.name}
                                      </i>
                                    ) : (
                                      <span className="font-medium-400 text-gray-750 text-sm">
                                        //
                                      </span>
                                    )}
                                  </li>
                                </ul>
                              );
                            })
                        )}
                      </div>
                    </Td>
                    <Td>
                      <div className="flex justify-between">
                        <div>
                          {usr?.data?.roles.length > 0 &&
                            usr?.data?.roles?.map((roleP) => {
                              return (
                                CHECK_PERMISSIONS(
                                  roleP?.permissions,
                                  "Modifier les informations d'un rôle"
                                ) && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    className="h-6 w-6 text-orange-400"
                                    role="button"
                                    onClick={() => {
                                      setIsOpenUM(true);
                                      setRoleId(role?.id);
                                    }}
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                    />
                                  </svg>
                                )
                              );
                            })}
                        </div>
                      </div>
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>
      </div>

      {/* Modal création d'un user */}
      <AddRole isOpen={isOpen} onClose={() => { onClose(); }} getRoles={fetchDataU} />

      {/* Modification des informations du role */}
      <UpdateRole
        fetchData={fetchDataU}
        isOpen={isOpenUM}
        setIsOpen={setIsOpenUM}
        onClose={closeUM}
        roleId={roleId}
      />
    </div>
  );
};

export default Roles;